function component(path) {
  return () => import(`src/views/${path}`)
}


const routes = [
  {
    path: '/',
    component: component('index.vue'),
    name: 'home'
  }
]

export default routes
